var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1755052494848,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 10969,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1024 797v131c0 53-43 96-96 96h-96c-53 0-96-43-96-96V797c0-26.5 10.7-50.5 28.1-67.9 17.4-17.4 41.4-28.1 67.9-28.1 8.8 0 16-7.2 16-16v-77c0-17.7-14.3-32-32-32H560c-8.8 0-16 7.2-16 16v94c0 8.3 6.7 15 15 15h1c53 0 96 43 96 96v131c0 53-43 96-96 96h-96c-53 0-96-43-96-96V797c0-53 43-96 96-96h1c8.3 0 15-6.7 15-15v-94c0-8.8-7.2-16-16-16H208c-17.7 0-32 14.3-32 32v77c0 4.4 1.8 8.4 4.7 11.3 2.9 2.9 6.9 4.7 11.3 4.7 53 0 96 43 96 96v131c0 53-43 96-96 96H96c-53 0-96-43-96-96V797c0-26.5 10.7-50.5 28.1-67.9C45.5 711.7 69.5 701 96 701c8.8 0 16-7.2 16-16v-77c0-53 43-96 96-96h256c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-48c-53 0-96-43-96-96V96c0-53 43-96 96-96h192c53 0 96 43 96 96v192c0 53-43 96-96 96h-48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h256c53 0 96 43 96 96v77c0 8.8 7.2 16 16 16 53 0 96 43 96 96z",
    "p-id": 10970,
    fill: "#1f2937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnow);
export default __webpack_public_path__ + "static/media/know.9e2c3915.svg";
export { ForwardRef as ReactComponent };